import Accordion from './component/accordion'
import More from './component/more'
import HamburgerMenu from './component/hamburgerMenu'
import PageTop from './component/pageTop'
import smoothScroll from './component/smoothScroll'
import { scrollAnimation } from './module/scrollAnimation'


window.addEventListener('load', () => {
  new Accordion.init('.js-accordionBtn, .js-accordionClose');
  new More.init('.js-moreBtn');
  new HamburgerMenu().handleClick('js-hamburger')
  new HamburgerMenu().handleClick('js-overlay')
  new PageTop()
  new smoothScroll()
  // new loading()
  scrollAnimation()

});

